import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Prospectus = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Prospectus"
                breadEnd="Prospectus"
                breadMid="Prospectus"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="iframe-box">
                <iframe
                  src="https://online.anyflip.com/hjco/vfqa/index.html"
                  title="Prospectus"
                  seamless="seamless"
                  scrolling="no"
                  frameborder="0"
                  allowtransparency="true"
                  allowfullscreen="true"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Prospectus;
